import { render, staticRenderFns } from "./make-money.vue?vue&type=template&id=059d5f62&scoped=true&"
import script from "./make-money.vue?vue&type=script&lang=js&"
export * from "./make-money.vue?vue&type=script&lang=js&"
import style0 from "./make-money.vue?vue&type=style&index=0&id=059d5f62&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059d5f62",
  null
  
)

export default component.exports